/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from "react";
import PropTypes from "prop-types";
import { Collapse } from "reactstrap";
import classNames from "classnames";

/**
 * Wraps children around a collapsible section header
 */
class Section extends React.Component {
  constructor(props) {
    super(props);
    const { closed, subsection } = this.props;
    this.state = {
      open: !closed,
      subsection
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }

  render() {
    const { children, title } = this.props;
    const { open, subsection } = this.state;
    const fieldClassName = classNames({
      btn: true,
      "section-black": true,
      "btn-sm": subsection,
      "col-6": subsection
    });

    // if it's a section then add a horizontal line
    const sectionSeperator = !subsection ? <hr className="hr-black" /> : null;
    return (
      <React.Fragment>
        {sectionSeperator}
        <fieldset>
          <legend className={fieldClassName} onClick={this.toggle}>
            <h5>{title}</h5>
          </legend>
          <Collapse isOpen={open}>{children}</Collapse>
        </fieldset>
      </React.Fragment>
    );
  }
}
Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  // If this is true, the collapse will start closed
  closed: PropTypes.bool,
  // If true, will mark the component as a subsection, making the header smaller
  subsection: PropTypes.bool
};
Section.defaultProps = {
  closed: false,
  subsection: false
};
export default Section;



// WEBPACK FOOTER //
// ./src/views/components/Section.jsx